import React, { useState, useCallback, useEffect, useRef } from "react";
import "./YoutubeSection.css";
import companyLogo from "../../assets/images/G.png";
import myThumbnail from "../../assets/images/ghoomothumb.png";


const TESTIMONIALS = [
  {
    id: "4Q4vjM1p-vw",
    title: "Client Testimonials | GhoomoWorld Experiences | Community Travel",
    brand: "GhoomoWorld",
    logo: companyLogo,
  },
  {
    id: "4gS8xp7hzwQ",
    title: "Solo Traveller Diaries | Spiti Valley Trip | GhoomoWorld",
    brand: "GhoomoWorld",
    logo: companyLogo,
  },
  {
    id: "5woC3EeQSMY",
    title: "First Time Trekkers | Kedarkantha Experience | GhoomoWorld",
    brand: "GhoomoWorld",
    logo: companyLogo,
  },
  {
    id: "kSiK344hIOU",
    title: "Group Travel Stories | Meghalaya Roadtrip | GhoomoWorld",
    brand: "GhoomoWorld",
    logo: companyLogo,
  },
  {
    id: "UKag-9Me_XI",
    title: "Why We Travel With GhoomoWorld | Community Voices",
    brand: "GhoomoWorld",
    logo: companyLogo,
  },
];

export default function YoutubeSection({ testimonials = TESTIMONIALS }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(null);
  const total = testimonials.length;
  const dialogRef = useRef(null);

  const goPrev = useCallback(() => {
    setActiveIndex((i) => Math.max(0, i - 1));
  }, []);

  const goNext = useCallback(() => {
    setActiveIndex((i) => Math.min(total - 1, i + 1));
  }, [total]);

  const goTo = useCallback((i) => {
    setActiveIndex(i);
  }, []);

  const openPlayer = useCallback(() => {
    setPlayingIndex(activeIndex);
  }, [activeIndex]);

  const closePlayer = useCallback(() => {
    setPlayingIndex(null);
  }, []);

  // Close lightbox on Escape
  useEffect(() => {
    if (playingIndex === null) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") closePlayer();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [playingIndex, closePlayer]);

  const current = testimonials[activeIndex];

  return (
    <section className="yts-section" aria-label="Client video testimonials">
      <div className="yts-card">
        <button
          type="button"
          aria-label={`Play testimonial: ${current.title}`}
          className="yts-thumb-btn"
          onClick={openPlayer}
        >
          {/* <img
            src={`https://img.youtube.com/vi/${current.id}/hqdefault.jpg`}
            alt={`${current.brand} client testimonials video thumbnail`}
            loading="lazy"
            decoding="async"
          /> */}
          <img src={myThumbnail} />
          <span className="yts-play-icon" aria-hidden="true">
            <svg width="100%" height="100%" viewBox="0 0 56 56" fill="none">
              <circle cx="28" cy="28" r="26" fill="#FF3B30" />
              <path d="M22 18l16 10-16 10V18Z" fill="#ffffff" />
            </svg>
          </span>
        </button>

        <div className="yts-brand-row">
          <img
            src={current.logo}
            alt={current.brand}
            loading="lazy"
            decoding="async"
            className="yts-brand-logo"
          />
          <p className="yts-title">{current.title}</p>
        </div>
      </div>

      <div className="yts-controls">
        <button
          type="button"
          aria-label="Previous testimonial"
          className="yts-arrow-btn"
          disabled={activeIndex === 0}
          onClick={goPrev}
        >
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M12 15l-5-5 5-5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div role="tablist" aria-label="Testimonial slide" className="yts-dots">
          {testimonials.map((t, i) => (
            <button
              key={i}
              type="button"
              role="tab"
              aria-selected={i === activeIndex}
              aria-label={`Go to testimonial ${i + 1}`}
              className={`yts-dot${i === activeIndex ? " yts-dot--active" : ""}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>

        <button
          type="button"
          aria-label="Next testimonial"
          className="yts-arrow-btn"
          disabled={activeIndex === total - 1}
          onClick={goNext}
        >
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M8 5l5 5-5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {playingIndex !== null && (
        <div
          className="yts-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`Playing: ${testimonials[playingIndex].title}`}
          ref={dialogRef}
          onClick={(e) => {
            if (e.target === dialogRef.current) closePlayer();
          }}
        >
          <div className="yts-lightbox-inner">
            <button
              type="button"
              className="yts-lightbox-close"
              aria-label="Close video"
              onClick={closePlayer}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path
                  d="M4 4l12 12M16 4L4 16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <iframe
              className="yts-lightbox-iframe"
              src={`https://www.youtube.com/embed/${testimonials[playingIndex].id}?autoplay=1&rel=0`}
              title={testimonials[playingIndex].title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
}